import PhysicalLocation from "domain/physicalLocation";
import Commodity from "domain/commodity";
import { Trader } from "features/settings/traders/trader";

export default class PageFilter {
    willSell?: boolean = true;
    locations: PhysicalLocation[] = [];
    commodities: Commodity[] = [];
    traders: Trader[] = [];
    search: string = null;
}

export function getPageFilterForUser(pageFilter: PageFilter, isCustomer: boolean) : PageFilter {
    return pageFilter != null ?     
        {
            ...pageFilter,
            willSell: !isCustomer ? pageFilter.willSell : null
        } 
        : pageFilter;
}